import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const UpdateStatus = MatxLoadable({
    loader: () =>
        import ("./UpdateStatus")
})
const AllUpdateStatus = MatxLoadable({
    loader: () =>
        import ("./AllUpdateStatus")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const UpdateStatusRoutes = [
    {
        path: "/update_status",
        component: AllUpdateStatus,
        // settings
    },

];

export default UpdateStatusRoutes;